import { throttle } from 'lodash-es';
import { useCallback, useMemo } from 'react';
import { atom, useAtomValue, useSetAtom } from 'jotai';
import { create, CreateBody, list } from 'services/api/trigger';

export const triggerState = atom<General.Trigger[]>([
  'LOGIN',
  'GUIDE',
  'REMIND',
  'REVIEW',
  'REVIEWGUIDE',
  'AIDE',
  'MARKETING_GUIDE',
  'MARKETING_PRAISE_TRIGGER',
  'INVITE_BUTTON_CLICK',
  'DASHBOARD_BOT_PRAISE_REMINDER_TIPS',
  'DASHBOARD_LAZADA_REVIEW_TIPS',
  'NEWUSER_INCENTIVE_NOTICE',
  'DASHBOARD_TOKOPEDIA_TIPS',
  'DASHBOARD_TOKOPEDIA_TIPS2',
  'KNOWLEDGE_TYPING_1',
  'KNOWLEDGE_TYPING_2',
  'KNOWLEDGE_TYPING_3',
  'ACTIVITY_HELP_HIDDED',
  'FRESH_GUIDE',
  'BOOT_GUIDE',
  'EDIT_CITE_KNOWLEDGE',
  'DELETE_CITE_KNOWLEDGE',
]);

export const useTriggerValue = () => {
  return useAtomValue(triggerState);
};

export const useSetTriggerValue = () => {
  return useSetAtom(triggerState);
};

export const triggerMap = atom((get) => {
  const triggerValue = get(triggerState);

  return triggerValue.reduce<Partial<Record<General.Trigger, boolean>>>((res, trigger) => {
    res[trigger] = true;

    return res;
  }, {});
});

export const useTriggerMapValue = () => {
  return useAtomValue(triggerMap);
};

export const useCreateTrigger = () => {
  const setTriggerValue = useSetTriggerValue();

  return useCallback(
    (body: CreateBody) => {
      setTriggerValue((pre) => [...pre, body.trigger]);

      return create(body)
        .then(() => {
          return list().then((res) => {
            setTriggerValue(res);
          });
        })
        .catch(() => {});
    },
    [setTriggerValue],
  );
};

const useTrigger = (triggerKey: General.Trigger) => {
  const { [triggerKey]: tiggered } = useTriggerMapValue();
  const realTrigger = useCreateTrigger();
  /**
   * 触发
   */
  const tickle = useMemo(
    () =>
      throttle(() => {
        if (tiggered) {
          return;
        }
        realTrigger({ trigger: triggerKey });
      }, 300),
    [realTrigger, tiggered, triggerKey],
  );
  return { tiggered, tickle };
};

export default useTrigger;
